import React from 'react'
import {
    RegistrationPageOneComp,
    RegistrationPageTwoComp,
    RegistrationPageThreeComp,
    RegistrationPageFourComp,
    RegistrationPageFiveComp,
    RegistrationPageParticipantComp,
    RegistrationPageSixComp,
    FinishPaymentIndividu,
    ThankYouComp
} from '../../'


const CardBodyComp = (props) => {

    switch (props.page) {
        case 1:
            return (
                <>
                    <RegistrationPageOneComp
                        page={props.page}
                    />
                </>
            );
        case 2:
            return (
                <>
                    <RegistrationPageTwoComp />
                </>
            );
        case 3:
            return (
                <>
                    <RegistrationPageThreeComp />
                </>
            );
        case 4:
            return (
                <>
                    <RegistrationPageFourComp />
                </>
            );
        case 4.5:
            return (
                <>
                    <RegistrationPageParticipantComp />
                </>
            );
        case 5:
            return (
                <>
                    <RegistrationPageFiveComp />
                </>
            );
        case 6:
            return (
                <>
                    <RegistrationPageSixComp />
                </>
            );
        case 7:
            return (
                <>
                    <FinishPaymentIndividu />
                </>
            );
        case 8:
            return (
                <>
                    <ThankYouComp />
                </>
            );
        default:
            return (
                <>
                    <RegistrationPageOneComp />
                </>
            );
    }
}

export default CardBodyComp
